var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('div',[(this.auth.currentUser)?_c('div',[_c('PaymentsHeader'),_c('HostedFields')],1):_vm._e()]),_c('DashboardFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }